@if(field()){
<label [for]="field().fieldId.toString()">{{ label }}</label>
<mat-form-field>  
  
  <input  matInput
         [id]="field().fieldId.toString()"
         [type]="field().renderType.type"
         [placeholder]="label!"
         [formControl]="formControl"
         autocomplete="off"
         aria-autocomplete="none"
         list="autocomplete-off">
  @if(formControl.errors?.['required']){
  <mat-error>{{ label }} is <strong>required</strong></mat-error>
  }
  @if(formControl.errors?.['email']){
  <mat-error>Please enter a valid email address</mat-error>
  }
  @if(formControl.errors?.['pattern']){
  <mat-error>{{ label }} has an <strong>invalid format</strong></mat-error>
  }
</mat-form-field>
}

